import { useState } from 'react';
import { nanoid } from 'nanoid';

export default function useDefaultToRandomId(id) {
  const [safeId] = useState(() => id || `id-${nanoid()}`);
  return safeId;
}
